import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'drRemoveHtmlTags'
})
export class DrRemoveHtmlTagsPipe implements PipeTransform {

    constructor() {}

    transform(textWithHtml: string): string {
        const div = document.createElement('div');
        div.innerHTML = textWithHtml;
        let cleanedText = div.textContent || div.innerText || ''; // Remove html tags
        cleanedText = cleanedText.replace(/\r?\n|\r|/g, ''); // Remove returns
        cleanedText = cleanedText.replace(/\s\s+/g, ' '); // Replaces all multi spaces by single spaces
        return cleanedText;
    }

}
